import {ChangeDetectorRef, Component, EventEmitter, inject, OnInit, Output, signal} from '@angular/core';
import {HttpErrorResponse, HttpStatusCode} from "@angular/common/http";
import {environment} from "projects/store/src/environments/environment";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {CustomMessageService, LocalStorageService, UtilService} from "library";
import {ActivatedRoute, Router} from "@angular/router";
import {LocalStorageKey, SalesWorkflow, SalesWorkflowSteps} from "projects/store/src/app/enums";
import {SalesWorkflowService} from "projects/store/src/app/services/api/v1/sales-workflow.service";
import {PathNavigationService} from 'projects/store/src/app/services/api/v1/path-navigation.service';
import {MacroFlowService} from 'projects/store/src/app/services/api/v1/macro-flow.service';
import {finalize} from "rxjs";

enum Options {
  "brands" = "brands",
  "percentage" = "percentage",
  "products" = "products",
}

const MSG_ERROR_LIMIT = "No es posible guardar el nuevo precio ingresado, por favor ingrese otro valor.";

interface Percentage {
  label: string;
  value: number;
}

interface AdditionalProduct {
  id: string | number;
  category: string;
  name: string;
  amount: number;
  discount_pct: number;
}


@Component({
  selector: 'app-sales-product-general',
  templateUrl: './sales-general-product.component.html',
})
export class SalesGeneralProductComponent implements OnInit  {
  requestService = inject(RequestService);
  private readonly customMessageService = inject(CustomMessageService);
  private readonly utilService = inject(UtilService);
  private cd = inject(ChangeDetectorRef);
  private readonly salesWorkflowService = inject(SalesWorkflowService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly pathNavigationService = inject(PathNavigationService);
  public readonly macroFlowService = inject(MacroFlowService);
  private readonly localStorageService = inject(LocalStorageService);


  requestId!: string;
  categoryId!: string;
  flowCode!: string;
  isEditingPrice = false;
  priceInputValue: number | null = null;
  showMsgErrorLimit = false;
  msgErrorLimit: string = '';

  products = signal<any>([]);
  frequencyOptions: any[] = []
  frequencySelected: any;
  categories = signal<any>([]);
  product = signal<any>({});
  productsByBrand: any[] = [];
  installment = signal<number>(0);
  brands = signal<any>([]);
  data = signal<any>({});
  readonly categoryCode = this.route.snapshot.params['category_code'];
  brandsFiltered: any[] = [];
  percentages: Percentage[] = [];
  selectedAmount: any;
  percentagesOnProduct : any[] = [];
  selectedPercentagesOnProduct : any;
  filteredFinalProductsOriginal: any[] = [];
  filteredFinalProducts: any[] = [];
  filteredFinalProductsByFilter : any[] = [];
  selectedQuote: any;
  selectedCategory: any;
  selectedBrands: any[] = [];
  categoryName: any;
  selectedPercentages: any[] = [];
  selectedPercentageInTheFilter: any[] = [];
  Options = Options;
  readonly orderedSteps: Options[] = [Options.products];
  internalStep = Options.products;
  showModalProductSummary = false;
  showModalMsg = false;
  showModalFilter = false;
  brandsTabOpen = false;
  abonoTabOpen = false;
  displayedProductCount = 0;
  searchText = '';
  path!: string;
  country = environment.global.country;
  orderByOptions = [
    {label: 'De la A a la Z', value: 'a-z'},
    {label: 'De la Z a la A', value: 'z-a'},
    {label: 'Mayor abono', value: '>abono'},
    {label: 'Menor abono', value: '<abono'},
    {label: 'Mayor cuota', value: '>cuota'},
    {label: 'Menor cuota', value: '<cuota'},
  ]

  frequency: { label: string; value: any; }[] = [];

  selectedOrder: string = '';
  loading = false;
  loadingQuotes = false;
  autogestionCliente = this.macroFlowService.getAutogestionClienteFlow();
  originalPriceInputValue: number | null = null;

  showRadioSelectionBox: boolean = false;
  allProductQuotes: any[] = [];
  additionalProducts: AdditionalProduct[] = [];
  hasAdditionalProducts = false;
  activeAccordionIndex: number | number[] = -1;
  additionalProductAdded = false;
  selectionAdditionalProduct: AdditionalProduct | null = null;
  showAdditionalProductAdded = false;
  showCancelButton = false;

  responsiveOptions: any[] | undefined;

  @Output() nextStepEvent = new EventEmitter();
  @Output() gotoStepEvent = new EventEmitter();

  ngOnInit() {
    this.data.set(this.requestService.request);
    this.requestId = this.route.snapshot.params['request_id'];
    this.path = this.route.snapshot.params['path'];
    this.flowCode = this.route.snapshot.params['flow_code'];
    this.categoryId = this.requestService.categoryId;
    this.categoryName = this.route.snapshot.params['category_code'];

    this.load(this.categoryId);
    this.loadAdditionalProductsAvailable();
    this.responsiveOptions = [
      {
        breakpoint: '1199px',
        numVisible: 1,
        numScroll: 1
      },
      {
        breakpoint: '991px',
        numVisible: 2,
        numScroll: 1
      },
      {
        breakpoint: '767px',
        numVisible: 1,
        numScroll: 1
      }
    ];
  }

  load(categoryId: string){
    this.utilService.enablePageLoading();
    this.requestService.getProductsByCategory(this.requestId ,categoryId).subscribe({
      next: (resp) => {
        if (resp.status == HttpStatusCode.Ok ){
          this.products.set(resp.body.data.list);
          this.extractBrands(this.products());
          this.productsByBrand = [...this.products()];
          this.filteredFinalProducts = [...this.products()];
          this.filteredFinalProductsOriginal = [...this.products()];
          this.displayedProductCount = this.filteredFinalProducts.length;
          this.onExtractGlobalPercentages(this.productsByBrand);
          this.internalStep = Options.products;
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }

        this.utilService.disablePageLoading();
      },
      error: (err: HttpErrorResponse) => {
        this.customMessageService.responseNoticeHandler(err);
        this.utilService.disablePageLoading();
      }
    })
  }

  loadAdditionalProductsAvailable(): void {
    const data = this.localStorageService.get(LocalStorageKey.data);
    const storeId = data?.store?.id;

    this.additionalProducts = [];
    this.hasAdditionalProducts = false;
    this.resetAdditionalProductAccordion();

    if (!storeId || !this.categoryId) {
      return;
    }

    this.requestService.getAdditionalProductsAvailable(storeId, this.categoryId).subscribe({
      next: (resp: any) => {
        if (resp.status === HttpStatusCode.Ok) {
          const list = resp.body?.data?.list;
          this.additionalProducts = Array.isArray(list) ? list : [];
          this.hasAdditionalProducts = this.additionalProducts.length > 0;
        } else {
          this.customMessageService.responseNoticeHandler(resp);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.customMessageService.responseNoticeHandler(err);
        this.additionalProducts = [];
        this.hasAdditionalProducts = false;
        this.resetAdditionalProductAccordion();
      }
    });
  }

  extractBrands(products: any){
    products.forEach((product: any) => {
      let brand = product.brand;
      const existBrand = this.brands().some((brand: any) =>  product.brand.id === brand.id);
      if (!existBrand) {
        this.brands().push(brand);
      }
    })

    this.brandsFiltered = this.brands().sort((a: { name: string; }, b: { name: string; }) => this.utilService.sortByText(a.name, b.name));

  }


  onSearchBrands($event: any) {
    const searchTerm = $event.target.value.toLowerCase();
    if(searchTerm){
      this.brandsFiltered = this.brands().filter( (brand: { name: string; }) => brand.name.toLowerCase().includes(searchTerm) );
    }else{
      this.brandsFiltered = [...this.brands()];
    }

  }

  onExtractProductsByBrands(){
    this.productsByBrand = [];
    this.selectedBrands.forEach((brand: any) => {
      const productsFiltered = this.products().filter( (product: any) => product.brand.id === brand.id );
      this.productsByBrand.push(...productsFiltered);
    })
    this.onExtractQuotaMax(this.productsByBrand);
    this.onExtractGlobalPercentages(this.productsByBrand);
    this.onFilterProduct(this.selectedAmount);
  }

  onExtractGlobalPercentages(products: any[]) {
    let globalMin: number | null = null;
    let globalMax: number | null = null;

    products.forEach((product: any) => {
      if (product.quotes && product.quotes.length > 0) {
        const min = product.quotes[0].installment.min;
        const max = product.quotes[0].installment.max;
        if (min !== null && (globalMin === null || min < globalMin)) {
          globalMin = min;
        }
        if (max !== null && (globalMax === null || max > globalMax)) {
          globalMax = max;
        }
      }
    });

    this.percentages = [];
    if (globalMin !== null && globalMax !== null) {
      for (let i: number = globalMin; i <= globalMax; i += 5) {
        this.percentages.push({ label: `${i}%`, value: i });
      }
    }
  }

  onCreateArrayPercentages( product: any ) {
    let minInstallment: number | null = null;
    let maxInstallment: number | null = null;


    minInstallment = product.quotes[0].installment.min
    maxInstallment = product.quotes[0].installment.max


    if (minInstallment === null || maxInstallment === null) {
      return;
    }

    this.percentages = [];

    for (let i: number = minInstallment; i <= maxInstallment; i+=5) {
      this.percentages.push( {
        label: `${i}%`,
        value: i
      });
    }

    this.percentagesOnProduct = [...this.percentages];
    this.selectedPercentagesOnProduct = this.percentagesOnProduct[0].value;
  }


  onFilterProduct(quotaAmount: number ){

     this.filteredFinalProductsOriginal = this.productsByBrand.filter((product: any) =>
      product.quotes.some((quota: any) => quota.quota.from <= Number(quotaAmount))
    );
    this.filteredFinalProducts = [...this.filteredFinalProductsOriginal];
    this.filteredFinalProductsByFilter = [...this.filteredFinalProducts];
  }

  onExtractQuotaMax(filterProducts: any){
    let maxQuota = 0;

    filterProducts.forEach( (product: any) => {
      product.quotes.forEach((quota: any) => {
        if (quota.quota.from > maxQuota) {
          maxQuota = quota.quota.from;
        }
      });

    });

    this.selectedAmount = maxQuota;

  }


  onCalculateFromQuota(quotes: any[]){
    let minQuota: number | null = null;


    quotes.forEach( (quote: any) => {
        if (minQuota === null || quote.quota.from < minQuota) {
          minQuota = quote.quota.from;
        }
    });

    return minQuota;

  }

  onCalculateFromInstallment(quotes: any[]){
    let minInstallment: number | null = null;


    quotes.forEach( (quote: any) => {
      if (minInstallment === null || quote.installment.from < minInstallment) {
        minInstallment = quote.installment.from;
      }
    });

    return minInstallment;

  }

  onCalculateProductPrice(){
    let productPrice: number | null = null;

    if(this.priceInputValue !== null && this.isPriceInputValueModified()) {
      return this.priceInputValue;
    }


    productPrice = this.product()?.quotes?.[0]?.prices?.suggested ?? null;
    this.originalPriceInputValue = productPrice;
    return productPrice;

  }


  getAdditionalProductNetAmount(product: AdditionalProduct | null = this.selectionAdditionalProduct): number {
    if (!product) {
      return 0;
    }

    const amount = Number(product.amount) || 0;
    const discountPct = Number(product.discount_pct) || 0;
    return amount * (1 - discountPct / 100);
  }

  getProductTotalAmount(): number {
    const productPrice = this.onCalculateProductPrice();
    if (!productPrice) {
      return 0;
    }

    if (!this.additionalProductAdded || !this.selectionAdditionalProduct) {
      return productPrice;
    }

    return productPrice + this.getAdditionalProductNetAmount();
  }

  getInstallmentAmount(withDecimals: boolean): number {
    const productTotalAmount = this.getProductTotalAmount();
    if (!productTotalAmount) {
      return 0;
    }

    let amount = ( productTotalAmount * Number(this.selectedPercentagesOnProduct) / 100)
    if(withDecimals) {
      return amount;
    }else{
      return Number(Math.floor(Number(amount.toFixed(2))).toFixed(2));
    }
  }

  getFinancedAmount(): number {
    const productTotalAmount = this.getProductTotalAmount();
    const installmentAmount = this.getInstallmentAmount(false);
    if (!productTotalAmount) {
      return 0;
    }
    return productTotalAmount - installmentAmount;
  }

  onCalculateAmount(withDecimals: boolean): number{
    return this.getInstallmentAmount(withDecimals);
  }

  onCalculateFinancedAmount(): number {
    return this.getFinancedAmount();
  }

  onCalculateAdditionalProductNetAmount(product: AdditionalProduct | null = this.selectionAdditionalProduct): number {
    return this.getAdditionalProductNetAmount(product);
  }

  onCalculateTotalFinancedAmount(): number {
    return this.getFinancedAmount();
  }

  buildAdditionalProductPayload(): {
    additional_product_id: string | number;
    category: string;
    name: string;
    amount: number;
    discount_pct: number;
    net_amount: number;
  } | undefined {
    if (!this.additionalProductAdded || !this.selectionAdditionalProduct) {
      return undefined;
    }

    return {
      additional_product_id: this.selectionAdditionalProduct.id,
      category: this.selectionAdditionalProduct.category,
      name: this.selectionAdditionalProduct.name,
      amount: this.selectionAdditionalProduct.amount,
      discount_pct: this.selectionAdditionalProduct.discount_pct,
      net_amount: this.onCalculateAdditionalProductNetAmount()
    };
  }

  onToggleAllBrands() {
    if (this.selectedBrands.length === this.brandsFiltered.length) {
      this.selectedBrands = [];
    } else {
      this.selectedBrands = [...this.brandsFiltered];
    }
    this.onApplyFilter();
  }

  onToggleAllPercentages() {
    if (this.selectedPercentages.length === this.percentages.length) {
      this.selectedPercentages = [];
    } else {
      this.selectedPercentages = this.percentages.map(p => p.value);
    }
    this.onApplyFilter();
  }

  onApplyFilter() {
    this.filteredFinalProducts = this.products().filter((product: any) => {
      const matchSearch = !this.searchText || product.name.toLowerCase().includes(this.searchText.toLowerCase());
      const matchBrand = this.selectedBrands.length === 0 || this.selectedBrands.some((brand: any) => product.brand.id === brand.id);
      const matchPercentage = this.selectedPercentages.length === 0 || this.selectedPercentages.some((p: number) => {
        const min = product.quotes[0]?.installment?.min;
        const max = product.quotes[0]?.installment?.max;
        return min !== null && max !== null && p >= min && p <= max;
      });
      return matchSearch && matchBrand && matchPercentage;
    });
    this.displayedProductCount = this.filteredFinalProducts.length;
  }


  orderBy() {
    this.loading = true;

    if (!this.selectedOrder) {
      this.loading = false;
      return;
    }
    setTimeout(() => {
      this.filteredFinalProducts = [...this.filteredFinalProducts].sort((a, b) => {
        switch (this.selectedOrder) {
          case 'a-z':
            return a.name.localeCompare(b.name);
          case 'z-a':
            return b.name.localeCompare(a.name);
          case '>abono':
            return this.getMaxInstallment(b) - this.getMaxInstallment(a);
          case '<abono':
            return this.getMaxInstallment(a) - this.getMaxInstallment(b);
          case '>cuota':
            return this.getMaxInstallment(b) - this.getMaxQuota(a);
          case '<cuota':
            return this.getMaxInstallment(a) - this.getMaxQuota(b);
          default:
            return 0;
        }
      });

      this.loading = false;
      this.showModalFilter = false;
    }, 500);
  }

  getMaxInstallment(product: any): number {
    if (!product.quotes || product.quotes.length === 0) {
      return 0;
    }

    return Math.max(...product.quotes.map((q: any) => q.installment.from));
  }

  getMaxQuota(product: any): number {
    if (!product.quotes || product.quotes.length === 0) {
      return 0;
    }

    return Math.max(
      ...product.quotes
        .map((q: any) => q.quota?.from ?? 0)
    );
  }

  // Método para restaurar todas las cuotas
  restoreAllQuotes() {
    if (this.allProductQuotes.length > 0) {
      const productCopy = structuredClone(this.product());
      productCopy.quotes = this.allProductQuotes;
      this.product.set(productCopy);
    }
  }

  getFilteredQuotes() {
    return this.product().quotes.filter(
      (q: any) => q.frecuency === this.frequencySelected
    );
  }

  onPercentageChange(){
    // this.restoreAllQuotes();
    const data = {
      price: this.getProductTotalAmount(),
      installment: this.getInstallmentAmount(true),
      quotas: this.product().quotes
        .filter((q: any) => q.frecuency === this.frequencySelected)
        .map((q: any) => ({
          quantity: q.quota.quantity,
          name: q.quota.name,
          monthly_interest: q.monthly_interest,
      })),
      payment_frequency: this.frequencySelected
    };
    this.showRadioSelectionBox = false;
    this.selectedQuote = undefined;
    this.loadingQuotes = true;
    this.requestService.getCalculationCreditInstallments(data, this.requestId)
      .pipe(finalize(() => {
        this.loadingQuotes = false;
        this.utilService.disablePageLoading();
      }))
      .subscribe({
      next: (result: any) => {
        if (result.status === HttpStatusCode.Ok) {
          this.calculateNewPaymentInstallment(result.body.data.list);
        }else{
          this.customMessageService.responseNoticeHandler(result);
        }
      },
      error: (err: any) => {
        this.customMessageService.responseNoticeHandler(err);
      }
    })

  }

  calculateNewPaymentInstallment(quotes: any[]) {
    const productCopy = structuredClone(this.product());

    // Primero, actualiza todas las cuotas que tengan la frecuencia seleccionada
    let filteredIndex = 0;
    productCopy.quotes.forEach((item: any) => {
      if (item.frecuency === this.frequencySelected) {
        const updateValues = quotes[filteredIndex];
        if (updateValues) {
          item.quota.quantity = updateValues.quantity;
          item.quota.from = updateValues.payment;
        }
        filteredIndex++;
      }
    });

    // Establece el producto con las cuotas actualizadas (manteniendo todas las frecuencias)
    this.product.set(productCopy);

    this.showRadioSelectionBox = true;
  }


  saveCalculateNewPaymentInstallment() {
    this.showModalProductSummary = false;
    this.selectedQuote.installment.selected = this.getInstallmentAmount(false);
    this.selectedQuote.prices.selected = this.getProductTotalAmount();
    this.product().payment_frequency = this.frequencySelected;
    this.selectedQuote.frecuency = this.frequencySelected;
    this.selectedQuote.quota.selected = this.selectedQuote.quota.from;
    /*this.selectedQuote.quota.monthly_interest = this.selectedQuote.quota.monthly_interest;*/
    const additionalProductPayload = this.buildAdditionalProductPayload();

    const data = {
      product: this.product(),
      quotes: this.selectedQuote,
      ...(additionalProductPayload ? {additional_product: additionalProductPayload} : {})
    };

    this.utilService.enablePageLoading();
    this.loading = true;
    this.requestService.update(this.requestId, data).subscribe({
      next: (resp)=> {
        if (resp.status === HttpStatusCode.NoContent) {
          this.onNextStep();
          return;
        }

        this.customMessageService.responseNoticeHandler(resp);
        this.utilService.disablePageLoading();
        this.loading = false;
      },
      error: (err: any) => {
        if ( err.status === HttpStatusCode.Locked) {
          this.handleRequestLocked(err as any);
        }else{
          this.customMessageService.responseNoticeHandler(err);
          this.utilService.disablePageLoading();
          this.loading = false;
        }
      }
    })
  }

  onReturnProductIcon(product: any) {
    return product.category.icon_url;


  }

  openModalProductSummary(product: any) {
    this.showModalProductSummary = true;
    product.quotes.sort((a: any, b: any) => a.quota.quantity - b.quota.quantity);
    this.onCreateArrayPercentages(product)
    this.product.set(product);
    this.setPaymentFrequency(product.payment_frequency);
    this.selectedPercentagesOnProduct = this.percentagesOnProduct[0].value;
    //TODO: se descomenta porque no se ocupa cuando se abre el modal
    //this.onPercentageChange();
    this.showMsgErrorLimit = false;
    this.isEditingPrice = false;
    this.priceInputValue = null;
    this.priceInputValue = this.onCalculateProductPrice();
    this.resetAdditionalProductAccordion();
    this.onPercentageChange();
  }

  onModalProductSummaryHide() {
    this.showModalProductSummary = false;
    this.resetAdditionalProductAccordion();
  }

  isPriceInputValueModified(): boolean {
    return this.priceInputValue !== this.originalPriceInputValue;
  }

  setPaymentFrequency(frequency: any) {
    this.frequency = frequency.map((f: any) => ({
      label: `${f} dias`,
      value: f
    }));
    this.frequency.sort((a: any, b: any) => a.quantity - b.quantity);
    this.frequencySelected = this.frequency[0].value ?? 15;
  }

  openModalFiltered(){
    this.showModalFilter = true;

  }

  onNextStep(){
    this.nextStepEvent.emit()
  }

  onGoToCategoryList(){
    // TODO mejorar ese general
    this.router.navigate([this.salesWorkflowService.buildUrl({
      flowCode: 'general',
      path: this.salesWorkflowService.getUrlStepByCode(SalesWorkflowSteps["select-category"]).path,
      requestId: this.route.snapshot.params['request_id'],
    })]);
  }

  onReturnCategoryIconAndName(){
    return this.products()[0]?.category || {};
  }

  get visitedSteps(): Set<Options> {
    return new Set(this.orderedSteps.slice(0, this.orderedSteps.indexOf(this.internalStep) + 1));
  }

  onGotoStep(step: Options) {
    if (this.orderedSteps.indexOf(step) <= this.orderedSteps.indexOf(this.internalStep)) {
      this.internalStep = step;
    }
  }

  onGotoStepNavigator(stepNavigator: { flowCode: string, stepCode: string }) {
    this.gotoStepEvent.emit(stepNavigator);
  }

  onGoInternalStep() {
    const nextIndex = this.orderedSteps.indexOf(this.internalStep) + 1;
    if (nextIndex < this.orderedSteps.length) {
      this.internalStep = this.orderedSteps[nextIndex];
    }
  }

  private handleRequestLocked(resp: any): void {
    const messageError = resp.error?.message ?? 'Solicitud no disponible';
    const attemptedUrl = this.utilService.getCurrentUrl();
    const state = { attemptedUrl, messageError };

    this.pathNavigationService.navigateToRequestNotAvailable(this.flowCode, state);
  }

  canEditPrice(): boolean {
    const data = this.localStorageService.get(LocalStorageKey.data);
    if (
      data &&
      data.store &&
      data.store.setting &&
      typeof data.store.setting.enabled_seller_price_change === 'boolean'
    ) {
      return data.store.setting.enabled_seller_price_change;
    }
    return false;
  }

  startEditPrice() {
    this.isEditingPrice = true;
    this.selectedQuote = undefined
    setTimeout(() => {
      const input = document.getElementById('productPriceInput');
      if (input) input.focus();
    });
  }

  finishEditPrice() {
    let maxProductPrice: number | null = null;
    let minProductPrice: number | null = null;

    this.product().quotes?.forEach((quote: any) => {
      if (minProductPrice === null && maxProductPrice === null) {
        minProductPrice = quote.prices.min;
        maxProductPrice = quote.prices.max;
      }
    });

    let errorMsg = '';
    if (
      maxProductPrice === null ||
      minProductPrice === null ||
      this.priceInputValue === null
    ) {
      errorMsg = MSG_ERROR_LIMIT;
    } else if (this.priceInputValue > maxProductPrice) {
      errorMsg = `Monto máximo: ${maxProductPrice}`;
    } else if (this.priceInputValue < minProductPrice) {
      errorMsg = `Monto mínimo: ${minProductPrice}`;
    }

    if (errorMsg) {
      this.msgErrorLimit = errorMsg;
      this.showMsgErrorLimit = true;
      setTimeout(() => {
        this.showMsgErrorLimit = false;
      }, 3000);
      return;
    }

    this.isEditingPrice = false;
    this.onPercentageChange();
  }

  addAdditionalProduct(): void {
    if (!this.selectionAdditionalProduct) {
      return;
    }

    this.additionalProductAdded = true;
    this.activeAccordionIndex = -1;
    this.onPercentageChange();

    setTimeout(() => {
      this.showCancelButton = true;
      this.showAdditionalProductAdded = true;
    }, 300);
  }

  editAdditionalProduct(event: Event): void {
    event.stopPropagation();
    this.activeAccordionIndex = 0;
  }

  removeAdditionalProduct(event: Event): void {
    event.stopPropagation();
    this.additionalProductAdded = false;
    this.selectionAdditionalProduct = null;
    this.activeAccordionIndex = -1;
    this.showAdditionalProductAdded = false;
    this.showCancelButton = false;
    this.onPercentageChange();
  }

  cancelEditionAdditionalProduct(): void {
    this.activeAccordionIndex = -1;
  }

  onAccordionClose(): void {
    if (!this.additionalProductAdded) {
      this.selectionAdditionalProduct = null;
    }
  }

  resetAdditionalProductAccordion(): void {
    this.activeAccordionIndex = -1
    this.additionalProductAdded = false;
    this.selectionAdditionalProduct = null;
    this.showCancelButton = false;
    this.showAdditionalProductAdded = false;
  }


  protected readonly SalesWorkflow = SalesWorkflow;
}
